import Api from './ApiService'

export default {
    get(keyword, pageNumber, filters, order) {
        const params = new URLSearchParams();

        params.append('keyword', keyword);
        params.append('pageNumber', pageNumber);
        params.append('orderColumn', order.column);
        params.append('orderSort', order.sort);

        // Serializando os filtros
        Object.keys(filters).forEach(key => {
            filters[key].forEach(value => {
                params.append(`${key}[]`, value);
            });
        });

        return Api().get(`users`, { params });
    },
    getUsersAulas(keyword, pageNumber, order) {
        return Api().post(`users/aulas?keyword=${keyword}&pageNumber=${pageNumber}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    getUserAvaliacoes(keyword, pageNumber, order) {
        return Api().post(`users/notas?keyword=${keyword}&pageNumber=${pageNumber}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    export(keyword, filters, order) {
        const params = new URLSearchParams();
        params.append('keyword', keyword);
        params.append('export', true);  // Parâmetro para exportar todos os dados
        params.append('orderColumn', order.column);
        params.append('orderSort', order.sort);

        // Serializando os filtros
        Object.keys(filters).forEach(key => {
            filters[key].forEach(value => {
                params.append(`${key}[]`, value);
            });
        });

        return Api().get('users', {
            params,
            responseType: 'blob' // Define o tipo de resposta como blob para tratar arquivos
        });
    },
    exportIds(keyword, filters, order, exportAll, onlyIds) {
        const params = new URLSearchParams();
        params.append('keyword', keyword);
        params.append('export', true);
        params.append('orderColumn', order.column);
        params.append('orderSort', order.sort);
        params.append('exportAll', exportAll);
        params.append('onlyIds', onlyIds);

        Object.keys(filters).forEach(key => {
            filters[key].forEach(value => {
                params.append(`${key}[]`, value);
            });
        });

        return Api().get('users', { params });
    },
    getUsersByIds(ids){
        return Api().post(`users/batch`, {ids});
    },
    getOne(id) {
        return Api().get(`users/${id}`);
    },
    createUser(data){
        return Api().post(`users`, data);
    },
    updateUser(credentials){
        return Api().put(`users/${credentials.id}`, credentials);
    }
}